import { Box, Card, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import RegisteredCircularProgressbar from "../ClinicianComponents/RegisteredCircularProgressBar";
import AddIcon from '@mui/icons-material/Add';
import { RiDeleteBin6Line, RiEditLine, RiStarFill, RiShieldStarLine, RiVerifiedBadgeFill, RiEyeLine, RiErrorWarningLine } from "react-icons/ri";
import PropTypes from "prop-types";
import './ClinicianLicenseStyling.css';
import './CardOverlay.css'; // Import CSS for styling
import { useNavigate } from "react-router-dom";
import './CardOverlay.css'; // Import CSS for styling
import DeleteModal from "../../../components/PopupModal/DeleteModal";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTMutation } from "../../../utils/useTMutation";
import showToast from "../../../components/Hot-Toast/showToast";

const ClinicianLicense = ({ data }) => {
    const { selectedTabData } = useSelector((state) => state.profileTabSection);
    const approvedLicenseCount = selectedTabData?.approvedLicenseCount;
    const navigate = useNavigate();
    console.log("Licencedata", data, approvedLicenseCount);
    const [deletePopup, setDeletePopup] = useState();
    const [selectedLicense, setSelectedLicense] = useState({});
    const { controlBy, controlAction } = useSelector(state => state.user);
    const AllViewControl = (controlAction === "view" && (controlBy === "facility" || controlBy === "admin"));
    const [licenses, setLicenses] = useState(data || []);

    const [percentage, setPercentage] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);

    const mutation = useTMutation("/deleteLicence", "delete", (data) => {
        if (data.STATUS) {
            console.log("data", data)
            console.log("data.STATUS", data.STATUS)
            return data;
        } else {
            showToast("error", data.MESSAGE, 3000);
        }
    });
    useEffect(() => {
        setLicenses(data || []);
    }, [data]);

    useEffect(() => {
        if (approvedLicenseCount > 0 && licenses.length > 0) {
            const test = (approvedLicenseCount / licenses.length) * 100
            setPercentage(test)

        }
    }, [approvedLicenseCount, licenses])
    const addNewLicense = () => {
        if (controlAction === 'edit' && controlBy === 'admin') {
            navigate("/admin/clinician-users/add-license");
        } else {
            navigate("/clinician/profile/add-license");
        }

    }
    const handleLicense = (licenseID) => {
        if (controlAction === 'edit' && controlBy === 'admin') {
            navigate(`/admin/clinician-users/edit-license/${licenseID}`);
        } else {
            navigate(`/clinician/profile/add-license/${licenseID}`);
        }

    }
    const handleViewLicense = (licenseID) => {

        if (controlAction === 'view' && controlBy === 'facility') {
            navigate(`/facility/clinican-users/view-license/${licenseID}`);
        } else {
            navigate(`/admin/clinician-users/view-license/${licenseID}`);
        }

    }

    const handleRemoveLicense = (license, index) => {
        setSelectedLicense(license);
        setDeletePopup(true);
    };

    const handleDelete = () => {
        setIsDeleting(true);
        mutation.mutate({ ID: selectedLicense.LICENSE_ID }, {
            onSuccess: (response) => {
                if (response.STATUS) {
                    setLicenses(prev => prev.filter(license => license.LICENSE_ID !== selectedLicense.LICENSE_ID));
                    showToast("success", "Licence Deleted successfully", 3000);
                }
                setSelectedLicense({});
                setDeletePopup(false);
                setIsDeleting(false);
            },
            onError: () => {
                setSelectedLicense({});
                setDeletePopup(false);
                setIsDeleting(false);
            }
        });
    };
    const closeDeleteModal = (event, reason) => {
        if (reason && reason === 'backdropClick') return;
        setSelectedLicense({});
        setDeletePopup(false);

    };

    return (

        <Card sx={{ padding: "20px", marginTop: 2 }}>
            <Grid container alignItems="center">
                <Grid item xs={12} sm={6}>
                    <Typography variant="h3" className="about_text_black">
                        License
                    </Typography>
                    <Typography variant="body1" className="desc-text" mt={1}>
                        An overview of the qualifications and authorizations required.
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={6} display="flex" justifyContent={"flex-end"}>

                    {AllViewControl ?
                        <Box display="flex" alignItems="center" >
                        </Box>
                        :
                        <Tooltip title="Add License">
                            <Box display="flex" alignItems="center" onClick={addNewLicense}>
                                <AddIcon sx={{ color: "#6ebe44", cursor: "pointer" }} fontSize="large" />
                            </Box>
                        </Tooltip>
                    }
                    <RegisteredCircularProgressbar text={`${approvedLicenseCount}/${licenses?.length}`} value={parseInt(percentage)} />
                </Grid>
            </Grid>

            <Grid container spacing={3} sx={{ justifyContent: 'flex-start' }}>
                {licenses?.map((license) => {
                    console.log("license", license)
                    return (
                        <Grid item xs={12} sm={6} md={4} lg={2.4} key={license.LICENSE_ID} >
                            <Card sx={{
                                padding: 2,
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                                height: 150, // Fixed square height
                                textAlign: 'left', // Align text to left
                                position: 'relative', // Allows positioning of warning icon
                                backgroundColor: "#f5f5f5",
                                borderRadius: "4px",

                            }}
                                className="card-container"

                            >
                                {/* Alarm Icon at the Top Center */}
                                <Box
                                    px={0}
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        backgroundColor: 'white',
                                        borderRadius: '50%',
                                        width: { xs: 30, sm: 40, md: 40 },
                                        height: { xs: 30, sm: 40, md: 40 },
                                        boxShadow: 1
                                    }}
                                >

                                    <RiShieldStarLine style={{ fontSize: { xs: 16, sm: 18, md: 20 }, color: "#6ebe44" }} />
                                </Box>

                                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                    <Box>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                wordBreak: 'break-word', overflowWrap: 'break-word', paddingX: "2", whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                width: "100%",
                                                maxWidth: "170px"
                                            }}
                                        >
                                            {license.LICENSE_NAME}
                                        </Typography>
                                    </Box>
                                    <Box>
                                        <Typography>
                                            {(license?.SET_AS_PRIMARY == true) && <RiStarFill color="#FFD700" />}
                                        </Typography>
                                    </Box>
                                </Box>


                                <Box
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    sx={{ width: '100%' }}
                                >
                                    <Box>
                                        <Typography variant="body1">{license.STATE_NAME}</Typography>
                                    </Box>

                                    <Tooltip title="Warning">
                                        <IconButton disableRipple sx={{ p: 0 }}>
                                            {license.DOCUMENT_RESPONSE_BY_ADMIN === "Approved" ? (
                                                <RiVerifiedBadgeFill style={{ color: "#6ebe44" }} />
                                            ) : (
                                                <RiErrorWarningLine
                                                    style={{
                                                        color:
                                                            license.DOCUMENT_RESPONSE_BY_ADMIN === "Rejected"
                                                                ? "#ff0000"
                                                                : "#FFD700"
                                                    }}
                                                />
                                            )}
                                        </IconButton>
                                    </Tooltip>
                                </Box>


                                <div className="card-overlay">
                                    {(controlBy === "admin" || controlBy === "facility") && controlAction === "view" && (
                                        <Tooltip tile="View">
                                            <IconButton className="overlay-button view">
                                                <RiEyeLine onClick={() => { handleViewLicense(license.LICENSE_ID) }} />
                                            </IconButton>
                                        </Tooltip>
                                    )}

                                    {(controlBy === "admin" || controlBy === "facility") && controlAction === "edit" && (
                                        <>
                                            <Tooltip tile="Edit">
                                                <IconButton className="overlay-button edit">
                                                    <RiEditLine onClick={() => { handleLicense(license.LICENSE_ID) }} />
                                                </IconButton>
                                            </Tooltip>
                                            {!(license?.SET_AS_PRIMARY) && (
                                                <Tooltip tile="Delete">
                                                    <IconButton className="overlay-button delete">
                                                        <RiDeleteBin6Line onClick={() => { handleRemoveLicense(license) }} />
                                                    </IconButton>
                                                </Tooltip>
                                            )}</>
                                    )}

                                    {((controlBy === "clinician" || controlBy === "") && controlAction === "") && (
                                        <>
                                            <Tooltip tile="Edit">
                                                <IconButton className="overlay-button edit">
                                                    <RiEditLine onClick={() => { handleLicense(license.LICENSE_ID) }} />
                                                </IconButton>
                                            </Tooltip>
                                            {!(license?.SET_AS_PRIMARY) && (
                                                <Tooltip tile="Delete">
                                                    <IconButton className="overlay-button delete">
                                                        <RiDeleteBin6Line onClick={() => { handleRemoveLicense(license) }} />
                                                    </IconButton>
                                                </Tooltip>
                                            )}
                                        </>
                                    )}

                                </div>

                            </Card>
                        </Grid>
                    )
                })}
            </Grid>




      <DeleteModal
        open={deletePopup}
        onClose={closeDeleteModal}
        handleDelete={handleDelete}
        selectedItem={selectedLicense?.LICENSE_NAME + " License"}
        loading={isDeleting}
      />
        </Card>
    )
};

export default ClinicianLicense;

ClinicianLicense.propTypes = {
    data: PropTypes.string.isRequired,


};